import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const ErrorsTranslations = wrapTranslationsSchema({
	name: 'ErrorsTranslations',
	title: 'Errors Translations',
	sanityId: 'errors',
	fields: {
		generic: 'Something went wrong',
		formErrorMessage: 'Error loading form',
		sorryMessage: 'We’re really sorry but something went wrong. Please try again later.',
		unknownError: 'Unknown Error',
		refreshPage:
			"While we work on fixing things, you can refresh the page to see if that helps. If that doesn't work, please try again later.",
		sorryMsg: "Sorry, we've encountered a problem",
		returnToHomepage: 'Return to Homepage',
		notFoundPageTitle: 'Page not found',
		notFound: 'Not Found',
		notFoundPageText:
			'Sorry, the page you were looking for was not found. Please try going back to the previous page or navigating to our home page.',
		notFoundActionText: 'Return to home page',
	},
});
